module.exports = __webpack_public_path__ + "static/01-dd6a9c99f071ca451057920ae4b145c3.jpg";